import { render } from "./Lorem.vue?vue&type=template&id=2e9c2266"
import script from "./Lorem.vue?vue&type=script&lang=js"
export * from "./Lorem.vue?vue&type=script&lang=js"

import "./Lorem.vue?vue&type=style&index=0&id=2e9c2266&lang=css"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__